import {action, makeAutoObservable} from "mobx"
import ElementModel from "../../model/ElementModel";
import {RootStore} from "../index";

export class PageMainStore {
    private rootStore: RootStore | undefined;

    arItemsNew = [];
    arItemsSpecials = [];
    arItemsStock = [];
    arItemsLoyalty = [];

    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
      //  this.arItemsNew=[];
      //  this.arItemsSpecials=[];
      //  this.arItemsStock=[];
        let ClientId=this.rootStore?.mainStore.getClientId();
        const limit=10;

        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isNovelty: true}
                }
            }
        }, this.setCatalogNew, this.setError);
        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isSellout: true}
                }
            }
        }, this.setCatalogSpecials, this.setError);
        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isSale: true}
                }
            }
        }, this.setCatalogStock, this.setError);
        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isIncludeLoyaltyProgram: true}
                }
            }
        }, this.setCatalogLoyalty, this.setError);
    }

    @action
    setCatalogNew = (result: any) => {
        this.arItemsNew = result.data.rows;
    }

    @action
    setCatalogSpecials = (result: any) => {
        this.arItemsSpecials = result.data.rows;
    }

    @action
    setCatalogStock = (result: any) => {
        this.arItemsStock = result.data.rows;
    }
    @action
    setCatalogLoyalty = (result: any) => {
        this.arItemsLoyalty = result.data.rows;
    }

    @action
    setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }


}
